<template>
    <div class="w-full">
        <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-12 md:gap-12" v-if="event && !isLoading">
            <div class="md:col-span-5">
                <img :src="event.poster" :alt="event.name"
                    class="w-full rounded-3xl object-cover shadow-lift ring-1 ring-white/[0.08] md:sticky md:top-28" loading="lazy" />
            </div>

            <div class="space-y-6 md:col-span-7">
                <div>
                    <p class="nl-eyebrow">Event</p>
                    <h1 class="nl-title mt-3 text-3xl leading-tight md:text-5xl">{{ event.name }}</h1>
                    <p class="mt-4 leading-relaxed text-nomad-200">{{ event.description }}</p>
                </div>

                <div class="nl-surface divide-y divide-white/[0.06]">
                    <a href="#" @click.prevent="openMap" class="group flex items-center gap-4 p-4 transition-colors hover:bg-white/[0.03]">
                        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-nomad-accent/10 text-nomad-accent"><span class="icon-map-pin"></span></span>
                        <div class="min-w-0 flex-1">
                            <p class="font-medium text-white">{{ event.venue }}</p>
                            <p class="text-sm text-nomad-400">
                                {{ event.street }}, {{ event.city }} {{ event.postal_code }}, {{ event.country.name }}
                            </p>
                        </div>
                        <span class="icon-external-link text-nomad-500 group-hover:text-nomad-accent"></span>
                    </a>
                    <div class="flex items-center gap-4 p-4">
                        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-nomad-accent/10 text-nomad-accent"><span class="icon-calendar"></span></span>
                        <span class="font-medium text-white">{{ event.date_at_formated }}</span>
                    </div>
                    <div class="flex items-center gap-4 p-4">
                        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-nomad-accent/10 text-nomad-accent"><span class="icon-tag"></span></span>
                        <span class="font-medium text-white">{{ event.price }}</span>
                    </div>
                    <div v-if="event.artists.length > 0" class="flex items-center gap-4 p-4">
                        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-nomad-accent/10 text-nomad-accent"><span class="icon-users"></span></span>
                        <div class="no-scrollbar flex min-w-0 flex-1 items-center gap-4 overflow-x-auto">
                            <div v-for="artist in event.artists" :key="artist.id" class="flex shrink-0 items-center gap-2">
                                <img v-if="artist.image" :src="artist.image" :alt="artist.name" class="h-8 w-8 rounded-full object-cover" />
                                <span class="whitespace-nowrap text-sm font-medium text-white">{{ artist.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <a v-if="event.ticket_url" :href="event.ticket_url" target="_blank" class="nl-btn-primary w-full !py-4 !text-base sm:w-auto">
                    <span class="icon-tag"></span> Get tickets
                </a>
            </div>
        </div>
    </div>
</template>
<script setup>
defineProps({ event: Object });
</script>
<script>
import { mapState, mapActions } from "vuex";
import { usePage } from "@inertiajs/vue3";
import { defineAsyncComponent } from 'vue'
import { join } from '@/utils/helpers';


export default {
    methods: {
        ...mapActions("event", ["getSignleEvent"]),
        openMap() {
            let address = [
                this.event.street,
                this.event.city,
                this.event.country.name,
                this.event.postal_code,
            ];

            address = join(address, "+");

            window.open("http://maps.google.com/?daddr=" + address, "_blank");
        },
    },
    created() {
        // const id = usePage().props.query.id;
        // console.og(id)
        // this.getSignleEvent(id);
    },
    computed: {
        ...mapState({ event: (state) => state.event.single }),
        ...mapState({ isLoading: (state) => state.event.isLoading }),
    },

    components: {
        'featured-artist': defineAsyncComponent(() => import("@/components/FeaturedArtist.vue")),
    },
    created() {
        document.title = this.event.name + " Event"
    },
};
</script>
